import styled from '@emotion/styled';
import { FlexContainer } from '../layout/Flex';
import { CopyButton } from './CopyButton';

const Container = styled('div')((p) => ({
  marginTop: p.theme.spacing(0.5),

  '> label': {
    display: 'block',
    color: p.theme.custom.colors.gray.w500,
    fontSize: p.theme.custom.fontSize.s
  }
}));

export const DataFieldWithLabel: React.FC<{
  label: React.ReactNode;
  copyToClipboardText?: string;
  preventOverflow?: boolean;
}> = ({ label, children, copyToClipboardText, preventOverflow = false }) => {
  return (
    <Container style={preventOverflow ? { width: '100%' } : {}}>
      <label>{label}</label>
      <FlexContainer>
        <div style={preventOverflow ? { width: '100%' } : {}}>{children}</div>
        {copyToClipboardText && <CopyButton text={copyToClipboardText} />}
      </FlexContainer>
    </Container>
  );
};
